export default {
  zh: {
    1: "您当前的账户状态：",
    2: "已到期",
    3: "未到期",
    4: "设备数量：",
    5: " 台设备",
    6: "套餐截止日期：",
    7: "申请注销",
    8: "在注销账号之前，需要验证您的账号安全：",
    9: "请输入密码",
    10: "申请注销",
    11: "申请审核中",
    12: "注销申请已提交，工作人员会在 10 日内审核您的注销申请",
    13: "撤销申请",
    14: "申请未通过",
    15: "您最近 10 日内执行过换绑或修改密码的操作，我们暂时无法判定您的账号处于安全状态",
    16: "重新申请",
    17: "您当前存在待审核的申请，注销申请提交失败。",
    18: "注销确认",
    19: "账户一旦注销成功则无法恢复，是否继续？",
    20: "继续注销",
    21: "取消",
    22: "密码不能为空",
    23: "密码错误",
    24: "注销申请提交成功",
    25: "注销申请提交失败",
    26: "撤销申请成功",
    27: "撤销申请失败",
  },
  en: {
    1: "Account Status:",
    2: "Expired",
    3: "Active",
    4: "Device Number:",
    5: " Devices",
    one_5: " Device",
    6: "Expiration Date:",
    7: "Delete Account",
    8: "Need to verify your account security before deleting account:",
    9: "Please enter password",
    10: "Delete Account",
    11: "Request Under Review",
    12: "The account deletion request has been submitted and will be reviewed within 10 days.",
    13: "Cancel Deletion",
    14: "Request Failed",
    15: "You have changed your account information or password within the last 10 days, it is temporarily unable to pass the security verification.",
    16: "Re-Request ",
    17: "The deletion request failed to be submitted because you currently have a pending request.",
    18: "Delete Confirmation",
    19: "Once you delete your account, you will not be able to restore your account. Are you sure you want to proceed?",
    20: "Delete ",
    21: "Cancel",
    22: "Password cannot be empty",
    23: "Incorrect password",
    24: "Account deletion request submitted successfully",
    25: "Account deletion request submitted failed",
    26: "Cancel deletion successfully",
    27: "Cancel deletion failed",
  },
};



// WEBPACK FOOTER //
// ./src/views/deleteAccount/lang.js